import Provider from "../data/provider";

export const apiProvider = new Provider();
